import { AbstractControl, FormControl } from '@angular/forms';
import { FormOverrideAddress } from '@domgen/dgx-fe-forms/address';
import { PersonalDetailsFormField } from './personal-details-form-field.enum';

export interface PersonalDetailsForm {
  [PersonalDetailsFormField.Address]: AbstractControl<FormOverrideAddress>;
  [PersonalDetailsFormField.EmailAddress]: FormControl<string | null>;
  [PersonalDetailsFormField.FirstName]: FormControl<string | null>;
  [PersonalDetailsFormField.LastName]: FormControl<string | null>;
  [PersonalDetailsFormField.PrivacyPolicy]: FormControl<boolean | null>;
  [PersonalDetailsFormField.TelephoneNumber]: FormControl<string | null>;
}
